import { domain } from 'modules/data';
import { FC } from 'react';

import SectionFields from '../../../components/SectionFields/SectionFields';
import ActivitySection from '../../card/ActivitySection';
import AddCommentSection from '../../card/AddCommentSection/AddCommentSection';
import AttachmentsSection from '../../card/AttachmentsSection';
import Toolbar from '../../card/Toolbar/Toolbar';
import { WorkflowSection } from '../../card/WorkflowSection';
import DearAdditionalChargeLines from '../DearAdditionalChargeLines/DearAdditionalChargeLines';
import DearItemLines from '../DearItemLines/DearItemLines';
import { DearRequestFooter } from '../DearRequestFooter/DearRequestFooter';
import * as hooks from './DearRequestCard.hooks';
import { messages } from './DearRequestCard.messages';
import { Root, ScrollableAreaStyled } from './DearRequestCard.styles';
import { DearRequestCardProps } from './DearRequestCard.types';

export const DearRequestCard: FC<DearRequestCardProps> = (props) => {
    const { className, request } = props;

    const details = request.details;

    const itemLines = hooks.useDearRequestCardLineItems(details);
    const additionalChargeLines = hooks.useDearRequestCardAdditionalChargeItems(details);

    const fieldsSupplierDetails = hooks.useDearRequestCardFieldsDefsSupplier(details);
    const fieldsAccountingDetails = hooks.useDearRequestCardFieldsDefsAccounting(details);
    const fieldsDefsShipping = hooks.useDearRequestCardFieldsDefsShipping(details);
    const fieldsDefsNotes = hooks.useDearRequestCardFieldsDefsNotes(details);

    return (
        <Root className={className}>
            <Toolbar request={request} />

            <ScrollableAreaStyled scrollResetKey={request.id}>
                {request.integrationCode === domain.IntegrationCode.DearPo && (
                    <SectionFields
                        title={messages.sectionTitleSupplierDetails}
                        fieldsDefs={fieldsSupplierDetails}
                        columnsCount={5}
                    />
                )}

                {request.integrationCode === domain.IntegrationCode.DearPo && (
                    <SectionFields
                        title={messages.sectionTitleAccountingDetails}
                        fieldsDefs={fieldsAccountingDetails}
                        columnsCount={5}
                    />
                )}

                {request.integrationCode === domain.IntegrationCode.DearPo && (
                    <SectionFields
                        title={messages.sectionTitleShippingDetails}
                        fieldsDefs={fieldsDefsShipping}
                        columnsCount={5}
                    />
                )}

                {request.integrationCode === domain.IntegrationCode.DearPo && (
                    <SectionFields fieldsDefs={fieldsDefsNotes} columnsCount={2} />
                )}

                <DearItemLines itemLines={itemLines} />

                <DearAdditionalChargeLines itemLines={additionalChargeLines} />

                <br />

                <DearRequestFooter request={request} />

                <AttachmentsSection request={request} />

                <WorkflowSection request={request} />

                <ActivitySection request={request} />

                {!request.flags.status.isDraft && <AddCommentSection request={request} />}
            </ScrollableAreaStyled>
        </Root>
    );
};
